var exports = {
  "UX": "PlutoniumUpsell.module__upsell___TUhCUl",
  "Kk": "PlutoniumUpsell.module__icon___TUhCUl",
  "Qs": "PlutoniumUpsell.module__content___TUhCUl",
  "Qq": "PlutoniumUpsell.module__text___TUhCUl",
  "o1": "PlutoniumUpsell.module__actions___TUhCUl",
  "R3": "PlutoniumUpsell.module__dismissLink___TUhCUl",
};

module.exports = exports;
